import rolesApi from 'utils/corporateRequest'
import instituteSelector from 'modules/Auth/selectors'
import studentRequest from 'utils/studentRequest'
import adminRequest from 'utils/adminRequest'

export const SET_SPECIALISATION_LIST = `corporate/SET_INDUSTRY_LIST`

export const setSpecialisationList = data => {
  return {
    type: 'SET_SPECIALISATION_LIST',
    data,
  }
}

export const setDashboardDriveList = list => {
  return {
    type: 'SET_DASHBOARD_DRIVE_LIST',
    list,
  }
}

export const setDashboardRoleList = list => {
  return {
    type: 'SET_DASHBOARD_ROLE_LIST',
    list,
  }
}

export const setDashboardDriveSingleList = list => {
  return {
    type: 'SET_DASHBOARD_DRIVE_SINGLE_LIST',
    list,
  }
}

export const setCandidateDriveList = list => {
  return {
    type: 'SET_CANDIDATE_DRIVE_LIST',
    list,
  }
}

export const setRoleMetrics = data => {
  return {
    type: 'SET_ROLE_METRICS',
    data,
  }
}

export const setDegreeList = data => {
  return {
    type: 'SET_DEGREE_LIST',
    data,
  }
}

export const setSingleRoleStudentDetails = data => {
  return {
    type: 'SET_SINGLE_ROLE_STUDENT_DETAILS',
    data,
  }
}

export const getDashboardDriveList =
  ({ page, search, selectionType, sortBy, orderBy, setLoading }) =>
  async (dispatch, getState) => {
    const state = getState()
    let pageKey = `pageLimit=10&currentPage=${page}`
    let occurrence = `&occurrence=${selectionType}`
    let searchKey = search ? `&search=${search}` : ''
    let sortKey = sortBy ? `&sort=${sortBy}` : ''
    let orderKey = orderBy ? `&order=${orderBy}` : ''
    setLoading(true)
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id
    try {
      const res = await rolesApi.get(
        `/instituteCampus/${instituteCampusId}/corporates/list?${pageKey}${occurrence}${searchKey}${sortKey}${orderKey}`
      )
      dispatch(setDashboardDriveList(res?.data?.data))
      setLoading(false)
      return true
    } catch (error) {}
  }

export const getDashboardRoleList =
  ({
    corpID,
    currentPage,
    selectionValue,
    search,
    filterQuery = null,
    sortBy,
    orderBy,
    setLoading,
    occurrenceFromParams,
  }) =>
  async (dispatch, getState) => {
    const state = getState()
    let pageKey = `pageLimit=10&pageNo=${currentPage}`
    let occurrence = selectionValue ? `&${selectionValue}` : ''
    let occurrenceParams = occurrenceFromParams
      ? `&occurrence=${occurrenceFromParams}`
      : ''
    let searchKey = search ? `&searchBy=${search}` : ''
    let sortKey = sortBy ? `&sort=${sortBy}` : ''
    let orderKey = orderBy ? `&orderBy=${orderBy}` : ''
    setLoading(true)
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id
    const institute_tier = instituteSelector.getInstituteDetails(state).tier
    try {
      const res = await rolesApi.get(
        `corporates/jobsByInstitute/${instituteCampusId}/lists?${pageKey}&tier=tier${institute_tier}&corporateId=${corpID}${occurrence}${searchKey}&${filterQuery}${sortKey}${orderKey}${occurrenceParams}`
      )
      dispatch(setDashboardRoleList(res?.data?.data))
      setLoading(false)
      return true
    } catch (error) {}
  }

export const getDashboardDriveSingleList =
  ({
    roleID,
    currentPage,
    selectionType,
    search,
    filterQuery = null,
    setLoading,
    sortQuery = '',
  }) =>
  async (dispatch, getState) => {
    const state = getState()
    let pageKey = `pageLimit=10&currentPage=${currentPage - 1}`
    let occurrence = `&occurrence=${selectionType}`
    let searchKey = search ? `&search=${search}` : ''
    let sortKey = sortQuery ?? ''
    setLoading(true)
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id

    try {
      const res = await rolesApi.get(
        `corporates/instituteCampus/${instituteCampusId}/role/${roleID}/drive/list?${pageKey}${occurrence}${searchKey}&${filterQuery}&${sortKey}`
      )
      dispatch(setDashboardDriveSingleList(res?.data))
      setLoading(false)
      return true
    } catch (error) {}
  }

export const getCandidateDriveList =
  ({
    driveID,
    status,
    stage,
    currentPage,
    searchValue,
    checkedIds,
    rolesMetrics,
    filterDatas,
    sortQuery,
    setIsLoading,
  }) =>
  async (dispatch, getState) => {
    const state = getState()
    let pageKey = `pageLimit=10&pageNo=${currentPage}`
    const search = searchValue ? `&searchBy=${searchValue}` : ''
    const degree =
      checkedIds?.length > 0 ? `&degreeStreamMapIds=${checkedIds}` : ''
    const specialisation = filterDatas?.specialisation
      ? `&specialisation=${filterDatas?.specialisation}`
      : ''
    const startBatch = filterDatas?.startBatch
      ? `&startBatch=${filterDatas?.startBatch}`
      : ''
    const endBatch = filterDatas?.endBatch
      ? `&endBatch=${filterDatas?.endBatch}`
      : ''
    const startDate = filterDatas?.startDate
      ? `&startDate=${filterDatas?.startDate}`
      : ''
    const endDate = filterDatas?.endDate
      ? `&endDate=${filterDatas?.endDate}`
      : ''
    const sort = sortQuery ? `&${sortQuery}` : ''

    setIsLoading(true)
    const candidateStatus = status
      ? `&status=${
          stage === 'offer'
            ? 'SELECTED'
            : stage === 'all_candidates'
            ? status === 'SCHEDULED,SHORTLISTED'
              ? 'SCHEDULED,SHORTLISTED,SELECTED'
              : status
            : status
        }`
      : ''

    const stageValue =
      stage !== 'all_candidates' && stage !== 'offer'
        ? `&stages=${stage}`
        : stage === 'offer'
        ? `&stages=${
            rolesMetrics[0]?.rounds[rolesMetrics[0]?.rounds?.length - 2]
              ?.roundName
          }`
        : ''
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id

    try {
      const res = await studentRequest.get(
        `students/drive/${driveID}/candidate/list?${pageKey}&collegeId=${instituteCampusId}${candidateStatus}${stageValue}${search}${degree}${specialisation}${startBatch}${endBatch}${startDate}${endDate}${sort}`
      )
      dispatch(setCandidateDriveList(res?.data?.data))
      setIsloading(false)
      return true
    } catch (error) {}
  }

export const getRoleMetrics =
  (driveId, roleIdValue = '') =>
  async (dispatch, getState) => {
    const state = getState()
    const instituteCampusId = instituteSelector.getInstituteDetails(state).id
    try {
      const roleId = roleIdValue ? `?roleId=${roleIdValue}` : ''
      const instituteCampusIdQuery = instituteCampusId
        ? `${roleIdValue ? '&' : '?'}instituteCampusId=${instituteCampusId}`
        : ''
      const response = await rolesApi.get(
        `/corporates/${driveId}/roles/metrics${roleId}${instituteCampusIdQuery}`
      )
      dispatch(setRoleMetrics(response?.data?.data || {}))
    } catch (error) {}
  }

export const getDegreeAndDepartMent = roleId => async (dispatch, getState) => {
  try {
    const response = await rolesApi.get(`/corporate/role/${roleId}/degree`)
    dispatch(setDegreeList(response?.data?.data || []))
  } catch (error) {
    //console.log(error)
  }
}

export const getSingleRoleStudentDetails =
  (roleID, stuID) => async (dispatch, getState) => {
    try {
      const res = await rolesApi.get(`/corporate/role/${roleID}/${stuID}`)

      dispatch(setSingleRoleStudentDetails(res?.data?.data))
    } catch (error) {}
  }

export const getSpecialisationList =
  ({ setIsLoading, keySpecialisation = '' }) =>
  async dispatch => {
    if (setIsLoading) {
      setIsLoading(true)
    }
    try {
      const myEncodedString = encodeURIComponent(
        keySpecialisation.toLowerCase()
      )
      const response = await adminRequest.get(
        `/student/specializationmaster/lists?special=${myEncodedString}`
      )
      dispatch(setSpecialisationList(response?.data?.data || []))
      if (setIsloading) setIsloading(false)
    } catch (error) {
      if (setIsloading) {
        setIsloading(false)
      }
    }
  }
